import React from 'react'

export const ReplyIcon = () => (
  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.22583 0L0 7.22583V8.49844L7.22583 15.7243L8.49844 14.4535L2.73395 8.68897H6.11859C11.1749 8.68897 14.3959 9.77644 16.3732 11.7968C18.354 13.819 19.2761 16.9681 19.2761 21.5409V22.17H21.0735V21.5409C21.0735 16.7848 20.1263 13.0568 17.6583 10.5386C15.1868 8.01492 11.3798 6.8915 6.11859 6.8915H2.87775L8.49844 1.27261L7.22583 0Z" fill="#030D21" />
  </svg>
)
